import React from "react";
import { motion } from "framer-motion";

const PageHero = ({
  overline,
  title,
  description,
  image,
  align = "left",
  testid = "page-hero",
}) => {
  return (
    <section
      className="relative pt-36 md:pt-44 pb-20 md:pb-28 overflow-hidden"
      data-testid={testid}
    >
      <div className="absolute inset-0 -z-10">
        {image && (
          <img
            src={image}
            alt=""
            aria-hidden="true"
            className="w-full h-full object-cover"
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-b from-background/50 via-background/80 to-background" />
        <div className="absolute inset-0 grain opacity-70" />
      </div>

      <div className="container relative">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className={`max-w-4xl ${align === "center" ? "mx-auto text-center" : ""}`}
        >
          {overline && (
            <div className="overline text-primary mb-5">— {overline}</div>
          )}
          <h1 className="font-display font-extrabold tracking-tight text-4xl md:text-6xl lg:text-7xl leading-[0.95]">
            {title}
          </h1>
          {description && (
            <p className="mt-6 max-w-2xl text-base md:text-lg text-muted-foreground leading-relaxed">
              {description}
            </p>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default PageHero;
